import { render, staticRenderFns } from "./AdminLayoutNavSVG.vue?vue&type=template&id=5c9fc789&scoped=true&"
import script from "./AdminLayoutNavSVG.vue?vue&type=script&lang=js&"
export * from "./AdminLayoutNavSVG.vue?vue&type=script&lang=js&"
import style0 from "./AdminLayoutNavSVG.vue?vue&type=style&index=0&id=5c9fc789&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9fc789",
  null
  
)

export default component.exports